/**
 * Circle exclamation icon for outbound messages that failed to send in OncoEMR.
 */

/** Props for {@link TaskMessageErrorIcon}. */
interface TaskMessageErrorIconProps {
  className?: string;
  width?: number;
  height?: number;
}

/**
 * Renders the failed-delivery error icon beside an outbound chat bubble.
 *
 * @param props - Optional class name and dimensions for the SVG.
 * @returns Red stroked circle-exclamation SVG for failed outbox rows.
 */
const TaskMessageErrorIcon = ({
  className,
  width = 24,
  height = 24,
}: TaskMessageErrorIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="#F50400"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TaskMessageErrorIcon;
